<template lang="pug">
    layout.contentTransparent
        div.layoutWrapper
            v-layout(row wrap)
                v-flex(xs12)
                    title-component(
                        type="h2"
                        slot="title"
                        :title="$t('feed.title')"
                    )

        template
            feed-list(:paginated="true")

        div.bottomSpacer
</template>

<script>
    import Layout from '../../Layout/Layout';
    import Title from '~components/Title';
    import FeedList from '../List';

    export default {
        components: {
            Layout,
            TitleComponent: Title,
            FeedList
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_mixins.styl";
    @import "../../../../assets/style/_variables.styl";

    .layoutWrapper
        padding-bottom: 8px

    .bottomSpacer
        height: 90px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .layoutWrapper
            margin-top: 20px
</style>
